import { cn as e } from "../../lib/utils.es.js";
import { Tooltip as t, TooltipContent as n, TooltipTrigger as r } from "../ui/tooltip.es.js";
import { UserAvatar as i } from "../UserAvatar/UserAvatar.es.js";
import { Icon as a } from "../Icon/Icon.es.js";
import { Fragment as o, jsx as s, jsxs as c } from "react/jsx-runtime";
// libs/ui-lib/src/components/DataTable/DataTableAuditCell.tsx
function l() {
	return /* @__PURE__ */ s(a, {
		"aria-hidden": "true",
		className: "pointer-events-none absolute -top-2 -right-1 size-4",
		dataTestId: "cortex-assisted-update-spark",
		library: "custom",
		name: "cortex-spark-icon",
		padding: 0,
		size: 16
	});
}
function u({ label: e, event: t }) {
	let { user: n } = t;
	return /* @__PURE__ */ c("div", {
		className: "flex flex-col gap-2",
		children: [/* @__PURE__ */ c("div", { children: [/* @__PURE__ */ s("div", {
			className: "font-semibold text-white",
			children: e
		}), t.when ? /* @__PURE__ */ s("div", {
			className: "text-white/75",
			children: t.when
		}) : null] }), /* @__PURE__ */ c("div", {
			className: "flex min-w-0 items-center gap-2",
			children: [/* @__PURE__ */ c("span", {
				className: "relative inline-flex size-6 shrink-0 rounded-full",
				children: [/* @__PURE__ */ s(i, {
					name: n.avatarName,
					seed: n.seed,
					size: "sm",
					showTooltip: !1
				}), t.withCortex ? /* @__PURE__ */ s(l, {}) : null]
			}), /* @__PURE__ */ c("div", {
				className: "min-w-0",
				children: [
					/* @__PURE__ */ s("div", {
						className: "truncate font-medium text-white",
						children: t.withCortex ? `${n.displayName} with Cortex` : n.displayName
					}),
					n.email ? /* @__PURE__ */ s("div", {
						className: "truncate text-white/70",
						children: n.email
					}) : null,
					!n.email && n.rawUserId ? /* @__PURE__ */ c("div", {
						className: "truncate text-white/70",
						children: ["User ID: ", n.rawUserId]
					}) : null
				]
			})]
		})]
	});
}
function d({ relativeTime: a, title: d, updated: f, updatedLabel: p = "Last updated", created: m, assistedUpdate: h, className: g }) {
	let _ = {
		...f,
		withCortex: f.withCortex ?? h?.isLatest ?? !1
	};
	return /* @__PURE__ */ c(t, { children: [/* @__PURE__ */ s(r, {
		asChild: !0,
		children: /* @__PURE__ */ c("div", {
			className: e("flex min-w-0 items-center gap-2", g),
			title: d,
			children: [/* @__PURE__ */ c("span", {
				className: "relative inline-flex size-6 shrink-0 rounded-full",
				children: [/* @__PURE__ */ s(i, {
					name: f.user.avatarName,
					seed: f.user.seed,
					size: "sm",
					showTooltip: !1
				}), h ? /* @__PURE__ */ s(l, {}) : null]
			}), /* @__PURE__ */ s("span", {
				className: "truncate text-foreground text-sm tabular-nums",
				children: a
			})]
		})
	}), /* @__PURE__ */ c(n, {
		className: "z-1100 flex min-w-64 flex-col gap-3 text-left",
		children: [/* @__PURE__ */ s(u, {
			label: p,
			event: _
		}), m ? /* @__PURE__ */ c(o, { children: [/* @__PURE__ */ s("div", { className: "h-px bg-white/15" }), /* @__PURE__ */ s(u, {
			label: "Created",
			event: m
		})] }) : null]
	})] });
}
export { d as DataTableAuditCell };
